<template>
  <div v-if="renderReady">
    <label v-if="getTitle" class="label">
      {{getTitle}}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>
    <div
      class="input"
      :class="{'state-error': model.$error, 'state-disabled': disabled && !borderless}"
    >
      <input
        v-if="!datePickerVisible"
        type="text"
        ref="input"
        :placeholder="datepicker.options.placeholder"
        :value="model.$value"
        readonly="readonly"
        autocomplete="off"
        @focus="toggleDatePicker()"
        :name="model.$form.testPath ? model.$path : undefined"
      >
      <datepicker
        v-if="datePickerVisible"
        ref="datePicker"
        :placeholder="datepicker.options.placeholder"
        :language="datepicker.language"
        :format="datepicker.options.format"
        :value="model.$model"
        :clear-button="datepicker.options.clearButton"
        :disabled="disabled"
        :disabledDates="disabledDates"
        :full-month-name="true"
        @input="dateChanged"
        @focus="onFocus($event)"
        @blur="pickerBlur($event)"
        @closed="pickerBlur($event)"
      ></datepicker>
    </div>
    <w-error
      :model="model"
      @focus="datePickerVisible ? $refs.input.focus() : $refs.datePicker.focus()"
    ></w-error>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js';
import {pl} from 'vuejs-datepicker/dist/locale';

export default {
  components: {WError, Datepicker, WTooltip},
  props: {
    placeholder: String,
    dateOptions: Object,
    disabledDates: Object
  },
  mixins: [modelMixin],
  data() {
    const dateOpts = {
      placeholder: this.placeholder || '',
      format: 'dd.MM.yyyy'
    };
    return {
      datePickerVisible: false,
      datepicker: {
        language: pl,
        value: '',
        options: {...dateOpts, ...this.dateOptions}
      }
    };
  },
  methods: {
    toggleDatePicker() {
      if (this.datePickerVisible) {
        this.hideDatePicker();
      } else {
        if (!this.model.$schema.readOnly) {
          this.showDatePicker();
        }
      }
    },
    showDatePicker() {
      this.datePickerVisible = true;
      const self = this;
      // pokae się dopiero za chwilę
      this.$nextTick(() => {
        self.$refs.datePicker.$el.children[0].children[0].focus();
        self.$refs.datePicker.showCalendar();
        self.model.$hasFocus = true;
      });
    },
    hideDatePicker() {
      this.datePickerVisible = false;
      const self = this;

      this.$nextTick(() => {
        self.model.$hasFocus = false;
        // self.$refs.datePicker.showCalendar();
      });
    },
    pickerBlur($event) {
      console.log('pickerBlur');
      this.hideDatePicker();
      // onBlur($event);
    },

    dateChanged(newValue) {
      const tnewvalue = newValue.getTime();
      if (tnewvalue !== this.localValue) {
        // this.resize(newValue);
        // console.log('dtpicker', newValue);
        this.localValue = tnewvalue;
        const pad = num => {
          if (num >= 10) {
            return num;
          } else {
            return '0' + num;
          }
          // const norm = Math.floor(Math.abs(num));
          // return (norm < 10 ? '0' : '') + norm;
        };
        // const stringValue = newValue.getFullYear() + '-' + pad(newValue.getMonth() + 1) + '-' + pad(newValue.getDate());
        const stringValue = pad(newValue.getDate()) + '.' + pad(newValue.getMonth() + 1) + '.' + newValue.getFullYear();
        // this.localValue = stringValue;
        this.$emit('input', stringValue);
        this.fieldChanged();

        if (!this.$options.vmodel) {
          if (this.$options.lazy) {
            // if (this.lazy) {
            // return;
          }
          // sets in model
          const nvalue = newValue.getFullYear() + '-' + pad(newValue.getMonth() + 1) + '-' + pad(newValue.getDate());
          // console.log('dt newvalue', nvalue);
          this.model.$model = nvalue;

          this.model.$hasFocus = false;
          // this.model.$value = stringValue;
          // this.hideDatePicker();
          // wymus odczyt
          // console.log(this.model.$value);
        }
      }
    }
    /*

    clickOutside() {
      this.hideDatePicker();

      document.removeEventListener('click', this.clickOutside, true);
    }
    */
  },
  watch: {
    dateOptions(next, prev) {
      this.datepicker.options = {...this.datepicker.options, ...next};
    },
    placeholder(next, prev) {
      this.$set(this.datepicker.options, 'placeholder', next);
    }
  }
};
</script>

<style>
.vdp-datepicker__calendar .cell.selected {
  color: #fff;
  background-color: #a90329;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  background-color: #428bca;
  color: white;
}
.vdp-datepicker__calendar header {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}
.vdp-datepicker__calendar .cell {
  border: 1px solid transparent !important;
}
.vdp-datepicker__calendar .cell.selected::before,
.vdp-datepicker__calendar .cell.selected::after {
  content: none;
}
</style>
